// extracted by mini-css-extract-plugin
export default {"buttonIcon":"Images_buttonIcon__at5ke","mainScreenImage":"Images_mainScreenImage__2nuqr"};